export default "__VITE_ASSET__DlKjbVWQ__"